import { render, staticRenderFns } from "./OverlayNav.vue?vue&type=template&id=056e3a0b&"
import script from "./OverlayNav.vue?vue&type=script&lang=js&"
export * from "./OverlayNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports